<template>
  <div class="parent-element">
    <div class="container">
      <el-container>
        <el-main>
          <p class="semiconductor-p2">
            半导体制造流程解决方案
          </p>
          <p class="semiconductor-p1">
            Semiconductor Manufacturing Process Solutions
          </p>
        </el-main>
      </el-container>
    </div>
    <div class="div-semicondcutor-01">
      <el-container>
        <el-main>
          <!-- <p class="semiconductor-p3">
            要实现高精度定量控制并非易事。飞卓科技多年潜心研发，已在工业过程控制仪器仪表等专业技术层面获得多项成就，<br />拥有大量DCS、PLC等集散控制系统的优秀应用经验，并在多个化工企业实际应用中取得良好反馈。<br />目前定量控制的精度可达0.5%，有力保障化工行业的生产效率及品质。
          </p> -->
        </el-main>
      </el-container>
    </div>
    <div class="div-semicondcutor-02">
      <el-main>
        <p class="semiconductor-p4">
          请尝试在半导体制造的各过程中搜索您要查找的产品
        </p>
        <p class="semiconductor-p8">
          Search each semiconductor manufacturing process for the product you
          are looking for
        </p>
      </el-main>
    </div>
    <div>
      <div class="button-list div-semicondcutor-03">
        <button
          v-for="(buttonText, index) in buttonList"
          :key="index"
          :index="index"
          @click="toggleActive(index, buttonText)"
          :class="{
            'is-active': activeButtonIndex === index,
            selected: activeButtonIndex === index,
          }"
          ref="buttons"
        >
          <img
            class="img"
            :src="require(`@/assets/images/icon_${index + 1}.svg`)"
            alt="图片"
          />
          <br />
          <span
            class="imageText"
            style="position: relative;top: 20px; font-size: 16px; letter-spacing:0px"
          >
            {{ buttonText }}
          </span>
        </button>
      </div>
      <!-- <div class="div-semicondcutor-04" v-if="isDivVisible">
        <el-main>
          <h2 style="text-align: center;">{{ selectedButton }}</h2>
          <p class="semiconductor-p5">
            {{ selectedButtonText }}
          </p>
        </el-main>
      </div> -->
    </div>
    <div class="div-semicondcutor-04">
      <p class="semiconductor-p6">
        按类别筛选
      </p>
      <p class="semiconductor-p7">
        Choose category
      </p>
      <div class="button-container">
        <span style="display: inline-block;">
          <el-button
            ref="allButton"
            class="my-button"
            style="width: 50px; !important; text-align:center;"
            @click="searchProduct(null)"
          >
            <span style="position: relative; left: -12px;">全 部</span><br />
            <p
              style="font-size: 14px;!important; letter-spacing:0px; font-weight:500 !important;"
            >
              All
            </p>
          </el-button>
          <el-button
            class="my-button"
            @click="searchProduct('物液位计')"
            ref="allButtonOne"
            >物/液位仪表系列<br />
            <p
              style="font-size: 14px;!important; letter-spacing:0px; font-weight:500 !important;"
            >
              Level Transmitters
            </p></el-button
          >
          <el-button
            class="my-button"
            @click="searchProduct('压力仪表')"
            ref="allButtonTwo"
            >压力仪表系列<br /><P
              style="font-size: 14px;!important; letter-spacing:0px; font-weight:500 !important;"
              >Pressure Transmitters</P
            ></el-button
          >
          <el-button
            class="my-button"
            @click="searchProduct('温度仪表')"
            ref="allButtonThree"
            >温度仪表系列<br />
            <p
              style="font-size: 14px;!important; letter-spacing:0px; font-weight:500 !important;"
            >
              Temperature transmitters
            </p></el-button
          >
          <el-button
            class="my-button"
            @click="searchProduct('流量仪表')"
            ref="allButtonFour"
            >流量仪表系列<br />
            <p
              style="font-size: 14px;!important; letter-spacing:0px; font-weight:500 !important;"
            >
              Flow meters
            </p></el-button
          >
          <el-button
            class="my-button"
            @click="searchProduct('分析产品')"
            ref="allButtonFive"
            >分析系列<br />
            <p
              style="font-size: 14px;!important; letter-spacing: 0px; font-weight:500 !important;"
            >
              Analysis series
            </p></el-button
          >
          <el-button
            class="my-button"
            @click="searchProduct('物联硬件')"
            ref="allButtonSix"
            >物联硬件系列<br />
            <p
              style="font-size: 14px;!important; letter-spacing:0px; font-weight:500 !important;"
            >
              IoT hardware
            </p></el-button
          >
        </span>
      </div>
    </div>
    <div class="bod" style="padding: 0 0 1.875rem">
      <el-container>
        <el-main>
          <el-row>
            <el-col
              :xs="24"
              :sm="12"
              :md="8"
              :lg="6"
              v-for="(item, index) in chanPingList"
              :key="index"
            >
              <div
                v-if="item.isShelves == true"
                class="item"
                @click="actionProduct(item.id)"
              >
                <div
                  class="img-bg"
                  :style="{
                    backgroundImage: `url(${
                      item.pictureList ? item.pictureList[0] : ''
                    })`,
                  }"
                ></div>
                <div class="tit">
                  <div class="h2">{{ item.productModel }}</div>
                  <div class="h3">{{ getText(item, "title") }}</div>
                  <pre class="tex">{{ getText(item, "subtitle") }}</pre>
                  <pre class="tex">{{ getText(item, "categoryName") }}</pre>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-pagination
            :current-page="pageNo"
            :page-size="pageSize"
            :page-count="totalPages"
            :pager-count="5"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </el-main>
      </el-container>
    </div>
    <div class="advantage_num">
      <ul>
        <li
          class="wow fadeInLeft animated"
          style="visibility: visible; animation-name: fadeInLeft;"
        >
          <div class="img_box">
            <img
              src="../assets/images/advantage_01.jpg"
              alt="物位计，料位计，液位计"
            />
          </div>
          <div class="text_box" style="position:absolute; left: 50%; left: -32%;  z-index: 2; ">
            <span><em class="counter"> 19 </em><i> 年 </i></span>
            <p>
              专业经验
            </p>
          </div>
        </li>
        <li
          class="wow fadeInLeft animated"
          style="visibility: visible; animation-name: fadeInLeft;"
        >
          <div class="img_box">
            <img
              src="../assets/images/advantage_02.jpg"
              alt="物位计，料位计，液位计"
            />
          </div>
          <div class="text_box">
            <span style="position:absolute; z-index: 2;"
              ><em class="counter"> 70000 </em><i> + </i></span
            >
            <p
              style="
            position: absolute;
            top: 60%;
            z-index: 2;"
          
            >
              合作商户
            </p>
          </div>
        </li>
        <li
          class="wow fadeInLeft animated"
          style="visibility: visible; animation-name: fadeInLeft;"
        >
          <div class="img_box">
            <img
              src="../assets/images/advantage_03.jpg"
              alt="物位计，料位计，液位计"
            />
          </div>
          <div class="text_box">
            <span style="position:absolute; left: 80%; z-index: 2;"
              ><em class="counter"> 24 </em><i> 小时 </i></span
            >
            <p style="position:absolute; left: 82%; top: 60%; z-index: 2;">
              内提供解决方案
            </p>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="button-list-01">
      <div v-for="i in 3" :key="i">
        <img :src="require(`@/assets/images/advantage_0${i}.jpg`)" alt="图片" />
        <span
          style="position: relative;
        bottom: 280px;
        text-align: center;
        left: 35px;"
        >
          <span><em class="counter"> 19 </em><i> 年 </i></span>
          <p>
            专业经验
          </p>
          <span><em class="counter"> 70000 </em><i> + </i></span>
          <p>
            合作商户
          </p>
          <span><em class="counter"> 24 </em><i> 小时 </i></span>
          <p>
            内提供解决方案
          </p>
          <p class="img-text-01">{{ imgList[i - 1] }}</p>
          <p class="img-text-02">{{ imgList[i + 2] }}</p> 
        </span>
      </div> 
    </div> -->
    <div class="div_02">
      <div class="input_box">
        <div class="input_wrap text_01">
          <i class="el-icon-user-solid"></i>
          <input
            type="text"
            name="uname"
            placeholder="姓名"
            v-model="form.uname"
          />
          <span style="display: flex;"></span>
        </div>
        <div class="input_wrap text_02">
          <i class="el-icon-phone"></i>
          <input type="text" name="tel" placeholder="电话" v-model="form.tel" />
          <span></span>
        </div>
        <div class="input_wrap1 text_03">
          <i class="el-icon-message-solid"></i>
          <input
            type="text"
            name="email"
            placeholder="邮箱"
            v-model="form.email"
          />
          <span></span>
        </div>
        <div class="input_wrap2 text_04">
          <i class="el-icon-s-comment"></i>
          <textarea
            placeholder="留言……"
            name="message"
            class="message"
            v-model="form.message"
          ></textarea>
          <span></span>
        </div>
        <button class="sub_btn" @click="submitForm">提交</button>
      </div>
    </div>
  </div>
</template>
<script>
// import { ElButton } from 'element-ui';
import Store from "../store";
import { getLang } from "../plugins/common";
export default {
  toMenu(item) {
    if (this.$route.path !== item.url) {
      this.$router.push({ path: item.url });
    }
  },
  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });

    this.searchProduct(),
      // const activeButtonIndex = localStorage.getItem("activeButtonIndex");
      // if (activeButtonIndex !== null) {
      //   this.activeButtonIndex = parseInt(activeButtonIndex);
      // }
      this.$nextTick(() => {
        // 在 DOM 更新后设置选中状态
        this.$refs.allButton.$el.classList.add("is-active");
      });
  },
  computed: {
    selectedButtonText() {
      return this.buttonListText[this.selectedIndex];
    },
    filteredProducts() {
      if (this.filterCondition === "") {
        return [];
      }
      return this.productList.filter(
        (product) => product.type === this.filterCondition
      );
    },
    // activeButtonIndex: function() {
    //   return this.buttonStates.indexOf(true);
    // },
  },
  data() {
    return {
      form: {
        uname: "",
        tel: "",
        email: "",
        message: "",
      },
      buttonStates: [false, false, false, false, false, false, false],
      buttons: [
        { label: "All", value: "", selected: true },
        { label: "Level Transmitters", value: "物液位计", selected: false },
        { label: "Pressure Transmitters", value: "压力仪表", selected: false },
        {
          label: "Temperature Transmitters",
          value: "温度仪表",
          selected: false,
        },
        { label: "Flow Meters", value: "流量仪表", selected: false },
        { label: "Analysis Series", value: "分析产品", selected: false },
        { label: "IoT Hardware", value: "物联硬件", selected: false },
      ],
      buttonList: [
        "清洗",
        "绝缘涂料涂布",
        "显影",
        "剥离绝缘涂料",
        "退火",
        "镀膜",
        "曝光",
        "刻蚀",
        "抛光",
        "离子注入",
      ],
      buttonListText: [
        "Feejoy提供包括化学液体、化学气体、真空、压缩空气控制等全方位产品方案，满足半导体厂务设备到工艺设备的各种需求。快速查找商品请输入工艺名称、设备名称、工艺相关关键词。",
        "Feejoy的多功能、高性能化学液体用元件可以满足客户由于半导体回路细微化进程发展，对绝缘涂料涂布均匀度、处理速度、设备尺寸等要求越来越高而产生的各种需求。快速查找商品请输入工艺名称、设备名称、工艺相关关键词",
        "Feejoy的产品可靠性高，可以满足客户由于半导体回路细微化进程发展，需要让显影液保持洁净并稳定持续喷射的需求，为实现细微化工艺提供支持。快速查找商品请输入工艺名称、设备名称、工艺相关关键词。",
        "Feejoy可提供SPM等湿法工艺中使用的化学液体控制元件以及用于工艺气体、臭氧(O3)的工艺气体用精密元件。Feejoy的产品洁净度高，最大化降低工艺中异物进入的风险。包括气控阀、导气控制用、压缩空气用电磁阀在内，Feejoy提供全方位支持。快速查找商品请输入工艺名称、设备名称、工艺相关关键词。",
        "Feejoy提供离子注入机不可或缺的工艺气体小流量供气产品和真空腔、真空压力调节产品。产品包括各种工艺气体控制系统、真空阀、压缩空气用、N2用流量传感器等系列可供选择。快速查找商品请输入工艺名称、设备名称、工艺相关关键词。",
        "Feejoy的高性能工艺气体阀具有耐久度高、耐高温、大流量、响应速度快等特点，可以满足CVD、ALD等半导体镀膜设备对镀膜品质，镀膜速度的要求越来越高的需求，工艺气体，真空的高精度调节也越发重要。Feejoy为最新ALD工艺发展提供支持，同时还能提供高精度、真空压力控制等相关产品，为客户提供全方位保障。快速查找商品请输入工艺名称、设备名称、工艺相关关键词。",
        "Feejoy可提供纯水用阀，设备内N2用传感器等各种产品，可对应KrF, ArF, EUV等光源变化，为客户提供全方面支持。快速查找商品请输入工艺名称、设备名称、工艺相关关键词。",
        "Feejoy的工艺气体供气系统、流量模拟检测系统等，可以满足精密的细微化加工、精准的定点刻蚀效果需求，实现对工艺气体的高精度、高频率控制，可以严格调节温度，为先进刻蚀工艺提供支持。快速查找商品请输入工艺名称、设备名称、工艺相关关键词。",
        "Feejoy提供研磨液、纯水控制工艺中不可或缺的化学液体控制元件以及化学液体阀、岛阀产品，为小型化设备提供支持。快速查找商品请输入工艺名称、设备名称、工艺相关关键词。",
        "Feejoy可提供氮气、氩气等惰性气体用控制阀，以及把周边元件统合在一起的集成化系统。可提供退火设备不可或缺的大流量工艺气体供气系统方案。产品也包含惰性气体用流量传感器等，为客户提供全方位支持。快速查找商品请输入工艺名称、设备名称、工艺相关关键词。",
      ],
      // imgList: [
      //   "19年",
      //   "70000+",
      //   "24小时",
      //   "专业经验",
      //   "合作商户",
      //   "内提供解决方案",
      // ],
      prevSelectedIndex: 0,
      activeButtonIndex: null,
      selectedButton: "清洗",
      store: Store.state,
      // 产品列表
      chanPingList: [], // 产品列表
      totalPages: 0, // 数据总条数
      pageNo: 1, // 当前页码
      pageSize: 20, // 每页数据条数
      classifyName: "",
      index: 0,
      selectedIndex: 0,
      isDivVisible: true,
      allSelected: true,
      isActive: true,
      imageClass: "",
      imageText: "",
      filterCondition: "",
    };
  },

  methods: {
    toggleActive(index, buttonText) {
      this.activeButtonIndex = index;
      if (buttonText != null) {
        this.filterCondition = buttonText;
      }
      this.searchProduct(this.classifyName);
    },
    toggleActiveOne() {
      this.getProducts();
      // this.toggleActive()
    },
    getProducts() {
      // 获取产品列表
      let productList = this.chanPingList;
      if (this.filterCondition == "清洗") {
        productList = productList.filter((product) => {
          const keywords = [
            "磁致伸缩液位计",
            "紧凑型涡街流量计",
            "超声波流量计",
            "氮气液位计",
            "温度传感器",
            "电磁式电导率传感器",
          ];
          return keywords.some(
            (keyword) => product.title.indexOf(keyword) !== -1
          );
        });
        if (productList.length < this.pageSize) {
          this.pageNo = 1;
        }
      }
      if (this.filterCondition == "退火") {
        productList = productList.filter((product) => {
          const keywords = ["紧凑型涡街流量计"];
          return keywords.some(
            (keyword) => product.title.indexOf(keyword) !== -1
          );
        });
        if (productList.length < this.pageSize) {
          this.pageNo = 1;
        }
      }
      if (this.filterCondition == "镀膜") {
        productList = productList.filter((product) => {
          const keywords = [
            "多点式超声波流量计",
            "气体层流流量计",
            "超声波液位控制器（多点式）",
            "超声波液位计（多点式）",
            "压力传送器（VCR接头）",
          ];
          return keywords.some(
            (keyword) => product.title.indexOf(keyword) !== -1
          );
        });
        if (productList.length < this.pageSize) {
          this.pageNo = 1;
        }
      }
      if (this.filterCondition == "刻蚀") {
        productList = productList.filter((product) => {
          const keywords = ["磁致伸缩液位计", "气体层流流量计"];
          return keywords.some(
            (keyword) => product.title.indexOf(keyword) !== -1
          );
        });
        if (productList.length < this.pageSize) {
          this.pageNo = 1;
        }
      }
      if (this.filterCondition == "抛光") {
        productList = productList.filter((product) => {
          const keywords = ["磁致伸缩液位计", "气体层流流量计"];
          return keywords.some(
            (keyword) => product.title.indexOf(keyword) !== -1
          );
        });
        if (productList.length < this.pageSize) {
          this.pageNo = 1;
        }
      }
      if (this.filterCondition == "例子注入") {
        productList = productList.filter((product) => {
          const keywords = ["气体层流流量计"];
          return keywords.some(
            (keyword) => product.title.indexOf(keyword) !== -1
          );
        });
        if (productList.length < this.pageSize) {
          this.pageNo = 1;
        }
      }
      this.chanPingList = productList;
      this.totalPages = Math.ceil(productList.length / this.pageSize);
    },
    handleButtonClick(buttonText, index) {
      this.selectedButton = buttonText;
      this.selectedIndex = index;
      this.isDivVisible = true;
      this.$nextTick(() => {
        this.isDivVisible = true;
      });
    },
    async submitForm() {
      try {
        await this.$http.post(this.form);
      } catch (error) {
        console.log(error);
      }
    },
    // 点击分页器时触发
    handleCurrentChange(val) {
      this.pageNo = val;
      this.searchProduct(this.classifyName);
    },
    // 每页数据条数改变时触发
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchProduct();
    },
    async searchProduct(e) {
      if (e == null) {
        // 判断当前按钮是否已经有active类名，有则移除，没有则添加
        if (this.$refs.allButton.$el.classList.contains("is-active")) {
          this.$refs.allButtonOne.$el.classList.remove("is-active");
          this.$refs.allButtonTwo.$el.classList.remove("is-active");
          this.$refs.allButtonThree.$el.classList.remove("is-active");
          this.$refs.allButtonFour.$el.classList.remove("is-active");
          this.$refs.allButtonFive.$el.classList.remove("is-active");
          this.$refs.allButtonSix.$el.classList.remove("is-active");
          this.$refs.allButton.$el.classList.add("is-active");
          e = null;
        } else {
          // 先移除所有按钮的active类名，然后再对当前点击的按钮添加active类名
          this.$refs.allButtonOne.$el.classList.remove("is-active");
          this.$refs.allButtonTwo.$el.classList.remove("is-active");
          this.$refs.allButtonThree.$el.classList.remove("is-active");
          this.$refs.allButtonFour.$el.classList.remove("is-active");
          this.$refs.allButtonFive.$el.classList.remove("is-active");
          this.$refs.allButtonSix.$el.classList.remove("is-active");
          this.$refs.allButton.$el.classList.add("is-active");
        }
      }
      if (e == "物液位计") {
        // 判断当前按钮是否已经有active类名，有则移除，没有则添加
        if (this.$refs.allButtonOne.$el.classList.contains("is-active")) {
          this.$refs.allButtonOne.$el.classList.remove("is-active");
          this.$refs.allButton.$el.classList.add("is-active");
          e = null;
        } else {
          // 先移除所有按钮的active类名，然后再对当前点击的按钮添加active类名
          this.$refs.allButton.$el.classList.remove("is-active");
          this.$refs.allButtonTwo.$el.classList.remove("is-active");
          this.$refs.allButtonThree.$el.classList.remove("is-active");
          this.$refs.allButtonFour.$el.classList.remove("is-active");
          this.$refs.allButtonFive.$el.classList.remove("is-active");
          this.$refs.allButtonSix.$el.classList.remove("is-active");
          this.$refs.allButtonOne.$el.classList.add("is-active");
        }
      } else if (e == "压力仪表") {
        if (this.$refs.allButtonTwo.$el.classList.contains("is-active")) {
          this.$refs.allButtonTwo.$el.classList.remove("is-active");
          this.$refs.allButton.$el.classList.add("is-active");
          e = null;
        } else {
          // 先移除所有按钮的active类名，然后再对当前点击的按钮添加active类名
          this.$refs.allButton.$el.classList.remove("is-active");
          this.$refs.allButtonOne.$el.classList.remove("is-active");
          this.$refs.allButtonThree.$el.classList.remove("is-active");
          this.$refs.allButtonFour.$el.classList.remove("is-active");
          this.$refs.allButtonFive.$el.classList.remove("is-active");
          this.$refs.allButtonSix.$el.classList.remove("is-active");
          this.$refs.allButtonTwo.$el.classList.add("is-active");
        }
      } else if (e == "温度仪表") {
        if (this.$refs.allButtonThree.$el.classList.contains("is-active")) {
          this.$refs.allButtonThree.$el.classList.remove("is-active");
          this.$refs.allButton.$el.classList.add("is-active");
          e = null;
        } else {
          // 先移除所有按钮的active类名，然后再对当前点击的按钮添加active类名
          this.$refs.allButton.$el.classList.remove("is-active");
          this.$refs.allButtonOne.$el.classList.remove("is-active");
          this.$refs.allButtonTwo.$el.classList.remove("is-active");
          this.$refs.allButtonFour.$el.classList.remove("is-active");
          this.$refs.allButtonFive.$el.classList.remove("is-active");
          this.$refs.allButtonSix.$el.classList.remove("is-active");
          this.$refs.allButtonThree.$el.classList.add("is-active");
        }
      } else if (e == "流量仪表") {
        if (this.$refs.allButtonFour.$el.classList.contains("is-active")) {
          this.$refs.allButtonFour.$el.classList.remove("is-active");
          this.$refs.allButton.$el.classList.add("is-active");
          e = null;
        } else {
          // 先移除所有按钮的active类名，然后再对当前点击的按钮添加active类名
          this.$refs.allButton.$el.classList.remove("is-active");
          this.$refs.allButtonOne.$el.classList.remove("is-active");
          this.$refs.allButtonTwo.$el.classList.remove("is-active");
          this.$refs.allButtonThree.$el.classList.remove("is-active");
          this.$refs.allButtonFive.$el.classList.remove("is-active");
          this.$refs.allButtonSix.$el.classList.remove("is-active");
          this.$refs.allButtonFour.$el.classList.add("is-active");
        }
      } else if (e == "分析产品") {
        if (this.$refs.allButtonFive.$el.classList.contains("is-active")) {
          this.$refs.allButtonFive.$el.classList.remove("is-active");
          this.$refs.allButton.$el.classList.add("is-active");
          e = null;
        } else {
          // 先移除所有按钮的active类名，然后再对当前点击的按钮添加active类名
          this.$refs.allButton.$el.classList.remove("is-active");
          this.$refs.allButtonOne.$el.classList.remove("is-active");
          this.$refs.allButtonTwo.$el.classList.remove("is-active");
          this.$refs.allButtonThree.$el.classList.remove("is-active");
          this.$refs.allButtonFour.$el.classList.remove("is-active");
          this.$refs.allButtonSix.$el.classList.remove("is-active");
          this.$refs.allButtonFive.$el.classList.add("is-active");
        }
      } else if (e == "物联硬件") {
        if (this.$refs.allButtonSix.$el.classList.contains("is-active")) {
          e = null;
          this.$refs.allButtonSix.$el.classList.remove("is-active");
          this.$refs.allButton.$el.classList.add("is-active");
        } else {
          // 先移除所有按钮的active类名，然后再对当前点击的按钮添加active类名
          this.$refs.allButton.$el.classList.remove("is-active");
          this.$refs.allButtonOne.$el.classList.remove("is-active");
          this.$refs.allButtonTwo.$el.classList.remove("is-active");
          this.$refs.allButtonThree.$el.classList.remove("is-active");
          this.$refs.allButtonFour.$el.classList.remove("is-active");
          this.$refs.allButtonFive.$el.classList.remove("is-active");
          this.$refs.allButtonSix.$el.classList.add("is-active");
        }
      }
      let { data: res } = await this.$http.post("/c/product/ProductConductor", {
        pageSize: this.pageSize,
        titleLike: this.$route.query.titleLike,
        pageNo: this.pageNo, // 添加当前页码参数
        classifyName: e,
      });
      this.classifyName = e;
      this.chanPingList = res.data.records;
      this.totalPages = res.data.totalPages; // 更新数据总条数
      this.toggleActiveOne();
    },
    getText(parntProp, prop) {
      return getLang(this.$i18n.locale, parntProp, prop);
    },
    // 选中某个产品
    async actionProduct(id) {
      Store.setActionProduct(id);
      this.$router.push({
        path: "/product",
        query: {
          productId: id,
        },
      });
    },
  },
  watch: {
    activeButtonIndex: function(newIndex) {
      localStorage.setItem("activeButtonIndex", newIndex);
    },
  },
};
</script>
<style lang="less" scoped>
@import "~element-ui/lib/theme-chalk/index.css";
// style="width: 96px; height: 96px; margin-top: -46px; filter: brightness(0) invert(1); opacity: 0.6;"
.el-row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap; /* 允许换行 */

  /* 每个元素最大宽度为20% */
  /* 若一排最多只显示5个元素，则每个元素的占比为20% * 5 = 100% */
  /* 若一排显示的元素不足5个，则每个元素的占比为 100% / 元素个数 */
  & > * {
    flex-basis: 20%;
    flex-grow: 0; /* 禁止元素缩放 */
    flex-shrink: 0;
    max-width: 20%;
  }
  /* 元素不足5个时，让它们居中显示 */
  &.center > * {
    flex-basis: calc(100% / 5);
  }
}
.img {
  width: 96px;
  height: 96px;
  margin-top: -46px;
  // filter: grayscale(100%);
  opacity: 1;
  outline: none; /* 去掉聚焦时的虚线边框 */
}

.img:hover {
  filter: brightness(0%) invert(100%) !important;
  opacity: 1;
}

.img:active {
  filter: brightness(0%) invert(100%) !important;
  opacity: 1;
}

.img:selected {
  filter: brightness(0%) invert(100%) !important;
  opacity: 1;
}

.el-pagination {
  font-size: 16px !important;
  top: 30px;
  margin-top: 30px;
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  text-align: center;
}
.selected .imageText {
  color: white;
}
// .li {
//   font-size: 16px !important;
// }

.el-pager li {
  padding: 0 4px;
  font-size: 13px !important;
  min-width: 35.5px;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
  text-align: center;
}
.el-pager li.current {
  font-weight: bold;
}
.el-pager li.disabled {
  opacity: 0.5;
}
.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  display: inline-block;
  font-size: 16px;
  min-width: 35.5px;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  box-sizing: border-box;
}

.el-main {
  overflow: visible;
  box-sizing: border-box;
  letter-spacing: 0px;
}
@media screen and (max-width: 1920px) {
  html {
    font-size: 14px;
  }
}
.el-col-lg-6 {
  width: 20%;
}
* {
  font-family: "PingFang SC", "Calibri", "opensans", "GothicArial", "Arial",
    "Microsoft YaHei", "San Francisco", "Hiragino Sans GB", "Helvetica Neue",
    Helvetica, sans-serif;
  letter-spacing: 0;
  margin: 0;
  padding: 0;
}
header[data-v-0ce92274] {
  height: 6.25rem;
  padding-top: 1.875rem;
  box-sizing: border-box;
  line-height: 2.5rem;
  z-index: 3;
}
.div_02 {
  background: #2b3743;
  padding: 0rem 0 4rem;
}
h2 {
  text-align: center;
  margin-bottom: 20px;
}
.bod {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(235, 240, 244);
  margin-top: -3%;
}
.tit {
  position: relative;
  .h2 {
    line-height: 2.5rem;
    color: rgb(74, 186, 184);
    font-size: 1.3125rem;
  }
  .h3 {
    line-height: 1.875rem;
    font-size: 20px;
    height: 3em;
    margin: 0;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .tex {
    position: relative;
    color: #718096;
    width: 100%;
    padding-left: 0.625rem;
    padding-top: 1.25rem;
    line-height: 1.5625rem;
    word-break: break-all;
    word-wrap: break-word;
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    cursor: default;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
      Microsoft YaHei, Arial, sans-serif;
    font-size: 16px;
  }
}
.jia {
  position: absolute;
  right: 0;
  bottom: 1.875rem;
  display: inline-block;
  background-color: rgb(74, 186, 184);
  color: #fff;
  height: 1.6875rem;
  min-width: 5rem;
  padding: 0 0.625rem;
  text-align: center;
  line-height: 1.6875rem;
  border-radius: 0.8438rem 0 0 0.8438rem;
}
.item {
  cursor: pointer;
  height: 27.5rem;
  margin: 1.25rem 0.9375rem;
  border-radius: 0.9375rem;
  box-shadow: 0 0 0.9375rem #ddd;
  position: relative;
  border: 0.0625rem solid #ddd;
  transition: 0.5s;
  padding: 1.5rem;

  img,
  .img-bg {
    display: block;
    margin: 0 auto;
    width: 11.25rem;
    height: 11.25rem;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.item:hover {
  transform: translateY(-0.625rem);
  border: 0.0625rem solid #4abcb9;
}
.img-bg {
  display: block;
  margin: 0 auto;
  width: 11.25rem;
  height: 11.25rem;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
body {
  text-align: center;
}

.parent-element {
  position: relative;
  height: 100%;
}
.container {
  background-image: url(../assets/images/bg-image.jpg);
  padding: 5% 10%;
  position: relative;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  z-index: 2;
}

.semiconductor-p1,
.semiconductor-p2,
.semiconductor-p3,
.semiconductor-p4,
.semiconductor-p5,
.semiconductor-p6,
.semiconductor-p7 {
  text-align: center;
  color: #ffffff;
}

.semiconductor-p1 {
  letter-spacing: 0px !important;
  text-align: center;
  font-size: 20px;
  margin-top: 12px;
}

.semiconductor-p2 {
  letter-spacing: 0px;
  font-size: 36px;
  margin-top: 12px;
}

.semiconductor-p3 {
  font-size: 16px;
  margin-top: 24px;
  color: #1d1515;
  letter-spacing: 0px;
}

.semiconductor-p4 {
  letter-spacing: 0px;
  font-size: 22px;
  margin-top: 50px;
  font-weight: 600;
  color: #1d1515;
  text-rendering: geometricPrecision;
}

.semiconductor-p5 {
  width: 100%;
  font-size: 16px;
  margin-top: 1%;
  color: #1d1515;
  max-width: 60em;
  margin-left: auto;
  margin-right: auto;
}

.semiconductor-p6 {
  letter-spacing: 0px;
  font-size: 22px;
  margin-top: 30px;
  font-weight: 600;
  color: #1d1515;
  text-rendering: geometricPrecision;
}

.semiconductor-p7 {
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: #1d1515;
  margin-top: 6px;
}
.semiconductor-p8 {
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  margin-top: 12px;
}
.div-semicondcutor-01,
.div-semicondcutor-02,
.div-semicondcutor-03 {
  // margin-top: 1%;
  width: 100%;
  height: 100%;
}
.div-semicondcutor-04 {
  margin-top: 24px;
  text-align: center;
}

.div-semicondcutor-01 {
  line-height: 28px;
  text-align: center;
  width: 100%;
  height: 40%;
  position: relative;
  top: 0;
}

.button-list {
  display: flex;
  justify-content: center;
  padding: 0;
  margin-top: 50px;
}

.button-list-01 {
  color: #000;
  // background: #fff;
  padding: 0;
  font-size: 16px;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-top: 60px;
  width: 100%;
  flex-wrap: nowrap;
  bottom: 60px;
}

.button-list-01 img {
  margin-bottom: -50px;
  width: 100%;
  height: auto;
  object-fit: contain;
  background: rgba(37, 51, 62, 0.7) !important;
  transition: transform 0.3s ease-in-out;
}
.img-text-01 {
  bottom: 58%;
  font-style: normal;
  font-size: 100px;
  font-weight: 400;
  line-height: 0.11em;
  color: #ffffff;
  font-family: "GOTHIC";
}
.img-text-02 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 300;
  line-height: 32px;
  color: #ffffff;
  bottom: 58%;
}
@media only screen and (min-width: 100px) and (max-width: 1440px) {
  .img-text-01 {
    font-size: 76px;
  }
  .img-text-02 {
    font-size: 14px;
  }
}

.button-list button:hover {
  // filter: hue-rotate(120deg);
  cursor: pointer;
  // border: 0.0625rem solid #4abcb9;
  opacity: 0.8; /* 设置透明度为 50% */
  background-color: #4abcb9;
  color: #ffffff;
  // background-color: #4ec2bf;
}

.button-list button:focus {
  cursor: pointer;
  border: 0.0625rem solid #4abcb9;
  // opacity: 0.5; /* 设置透明度为 50% */
  color: #ffffff;
  background-color: #4ec2bf;
  // filter: grayscale(100%);
}

.button-list button:active,
.button-list button.selected {
  background-color: #4ec2bf;
}
.button-list button.selected img {
  filter: brightness(0) invert(1);
}
.button-list button {
  width: 133px;
  height: 171px;
  background-color: white;
  border: none;
  box-shadow: -4px 0 8px -4px rgba(0, 0, 0, 0.1),
    4px 0 8px -4px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

.button-list button:hover {
  width: 133px;
  height: 171px;
  background-color: #4ec2bf;
}

.button-list button img {
  transition: transform 0.3s ease-in-out;
}

.button-list button:hover img {
  filter: brightness(0%) invert(100%) !important;
  opacity: 1;
}

.button-list button:hover img {
  color: #ffffff;
  transform: scale(1.2);
  filter: brightness(0%) invert(100%) !important;
  opacity: 1;
}

.button-list button:focus img {
  filter: brightness(0%) invert(100%) !important;
  opacity: 1;
}
.button-list button:focus img,
.img:focus {
  filter: brightness(0%) invert(100%);
  opacity: 1;
}
.button-list button:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
}

.my-button {
  letter-spacing: 0px;
  background-color: #ffffff;
  color: #666;
  border: none;
  font-size: 16px;
  font-weight: 600;
  text-align: center !important;
  padding: 18px 18px 18px 18px !important;
}
.my-button span {
  display: inline-block;
  vertical-align: middle;
}
.my-button:hover {
  background-color: #4ec2bf;
  color: #fff;
}

// .my-button:active,
// .my-button:focus {
//   background-color: #4ec2bf;
//   color: #fff;
// }

.my-button:active {
  background-color: #4ec2bf;
  color: #fff;
}

.my-button.is-active {
  background-color: #4ec2bf !important;
  color: #fff !important;
}
.button-list.is-active {
  background-color: #4ec2bf !important;
  color: #fff !important;
}
// .button-list.is-active span {
//   color: #fff !important;
// }
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
  margin-top: 30px;
  margin-left: 30px;
  margin-bottom: 84px;
}

.el-button {
  width: 180px;
  line-height: 1.6;
  margin-left: 6px;
  margin-right: 6px;
}

.input_box {
  background: #2b3743;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 5%;
  width: 60%;
  margin-top: -5px; /* Adjust the value to fit your layout */
}
.input_box .input_wrap input:focus,
.input_box .input_wrap textarea:focus {
  outline: none;
}
.input_box .input_wrap input {
  background: #2b3743;
  width: 100%;
  line-height: 52px;
  height: 52px;
  background: rgba(255, 255, 255, 0.21);
  padding: 0 14px;
  font-size: 14px;
  border: 0;
  padding-left: 50px;
  background-repeat: no-repeat;
  background-size: 24px auto;
  background-position: 20px center;
  color: #fff;
}
.input_box .input_wrap1 input:focus,
.input_box .input_wrap1 textarea:focus {
  outline: none;
}
.input_box .input_wrap1 input {
  background: #2b3743;
  width: 100%;
  line-height: 52px;
  height: 52px;
  background: rgba(255, 255, 255, 0.21);
  padding: 0 14px;
  font-size: 14px;
  border: 0;
  padding-left: 50px;
  background-repeat: no-repeat;
  background-size: 24px auto;
  background-position: 20px center;
  color: #fff;
}
.input_box .input_wrap2 input:focus,
.input_box .input_wrap2 textarea:focus {
  outline: none;
}
.input_box .input_wrap2 input {
  background: #2b3743;
  width: 100%;
  line-height: 52px;
  height: 52px;
  background: rgba(255, 255, 255, 0.21);
  padding: 0 14px;
  font-size: 14px;
  border: 0;
  padding-left: 50px;
  background-repeat: no-repeat;
  background-size: 24px auto;
  background-position: 20px center;
  color: #fff;
}
.input_box .input_wrap textarea {
  width: 100%;
  height: 148px;
  border: none;
  padding: 14px;
  background: rgba(255, 255, 255, 0.21);
  padding-left: 50px;
  background-repeat: no-repeat;
  background-size: 24px auto;
  background-position: 20px 14px;
  color: #fff;
}
.input_box .input_wrap1 textarea {
  width: 100%;
  height: 148px;
  border: none;
  padding: 14px;
  background: rgba(255, 255, 255, 0.21);
  padding-left: 50px;
  background-repeat: no-repeat;
  background-size: 24px auto;
  background-position: 20px 14px;
  color: #fff;
}
.input_box .input_wrap2 textarea {
  width: 100%;
  height: 148px;
  border: none;
  padding: 14px;
  background: rgba(255, 255, 255, 0.21);
  padding-left: 50px;
  background-repeat: no-repeat;
  background-size: 24px auto;
  background-position: 20px 14px;
  color: #fff;
}

.input_box .sub_btn {
  color: #44bcb9;
  text-align: center;
  line-height: 44px;
  display: block;
  cursor: pointer;
  transition: all 3s;
  margin-top: 17px;
  font-size: 14px;
  margin: 40px auto 50px;
  width: 160px;
  height: 44px;
  background: rgba(255, 255, 255, 0.21);
  border-radius: 3px;
  transition: all 0.36s;
  border: none;
  box-shadow: none;
}
#app {
  overflow: hidden;
  background-color: rgb(19, 38, 49);
}
.input_box .sub_btn:hover::after {
  opacity: 1;
}
.input_box .input_wrap {
  width: 30%;
  margin-top: 17px;
  margin: 17px 0 0 0;
  position: relative;
}
.input_box .input_wrap1 {
  width: 70%;
  margin-top: 17px;
  margin: 17px 0 0 0;
  position: relative;
}
.input_box .input_wrap2 {
  width: 70%;
  margin-top: 17px;
  margin: 17px 0 0 0;
  position: relative;
}
.text_01 {
  left: 45%;
  position: relative;
}
.text_02 {
  left: 15%;
  position: relative;
}
.text_03 {
  width: 200% auto;
  left: 45%;
  top: 15px;
  position: relative;
}
.text_04 {
  margin-right: 10px; /* 调整两个输入框之间的距离 */
  left: 45%;
  top: 32px;
  position: relative;
}
.sub_btn {
  top: 220px;
  position: relative;
  background-color: gray;
}
.el-icon-user-solid {
  color: #4ec2bf;
  position: absolute;
  left: 8%;
  bottom: 20px;
}

.el-icon-phone {
  color: #4ec2bf;
  position: absolute;
  left: 8%;
  bottom: 20px;
}
.el-icon-message-solid {
  color: #4ec2bf;
  position: absolute;
  left: 3.5%;
  top: 16px;
}

.el-icon-s-comment {
  color: #4ec2bf;
  position: absolute;
  left: 3.5%;
  bottom: 152px;
}
.input_wrap1 input::placeholder {
  color: white; /*设置颜色*/
  font-size: 14px; /*设置字体大小*/
  // font-style: italic; /*设置字体样式*/
}
.input_wrap input::placeholder {
  color: white; /*设置颜色*/
  font-size: 14px; /*设置字体大小*/
  // font-style: italic; /*设置字体样式*/
}
.message::placeholder {
  color: white; /* 设置颜色 */
  font-size: 14px; /* 设置字体大小 */
  // font-style: italic; /* 设置字体样式 */
}
.advantage_num {
  width: 100%;
  height: 100%;
}
.advantage_num ul {
  overflow: hidden !important;
  display: flex;
}
.img_box {
  z-index: 1;
  background: rgba(37, 51, 62, 0.7) !important;
  width: 100%;
  position: relative;
  overflow: hidden !important;
}
.advantage_num ul li .text_box {
  width: 100%;
  height: 13%;
  position: absolute;
  top: 3060px;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(37, 51, 62, 0.7);
  color: #fff;
}
.advantage_num ul li .text_box em {
  font-style: normal;
  font-size: 100px;
  font-weight: 400;
  line-height: 1em;
  color: #ffffff;
  font-family: "GOTHIC" !important;
}

// .counter{
//   position: absolute;
//   left: 13%;
// }
// ul,
// ol,
// li {
//   list-style: none;
// }
</style>
